/**
 * Altair Logo — from official S7 Logo.svg
 * Uses currentColor for theme adaptivity.
 */

const LOGO_PATH =
  "M136.564,215.682 C148.633,192.726 160.483,170.066 172.328,147.416 C170.375,145.828 168.467,146.361 166.722,146.355 C151.057,146.297 135.391,146.441 119.73,146.222 C115.912,146.169 113.61,147.502 111.526,150.552 C105.796,158.939 99.848,167.179 93.882,175.402 C92.048,177.929 91.092,180.452 91.254,183.693 C91.594,190.515 88.438,195.197 82.919,196.913 C76.959,198.766 71.928,196.781 68.058,190.78 C67.015,189.163 65.705,188.014 64.18,186.995 C59.193,183.662 54.14,180.424 49.229,176.982 C45.51,174.374 41.98,172.524 36.953,173.141 C30.637,173.916 25.395,168.765 24.713,162.512 C23.985,155.842 28.093,150.048 34.408,148.837 C40.951,147.582 47.473,151.004 48.799,157.343 C49.594,161.147 51.643,163.058 54.535,164.848 C57.367,166.601 60.102,168.51 62.87,170.364 C72.285,176.668 77.857,175.524 84.504,166.056 C89.481,158.967 94.48,151.888 99.649,144.939 C101.935,141.866 101.786,139.938 98.39,137.74 C86.642,130.135 75.045,122.295 63.433,114.481 C61.537,113.205 59.765,112.821 57.408,113.127 C49.831,114.109 44.126,110.163 42.809,103.469 C41.454,96.583 45.023,90.898 52.426,88.871 C54.625,88.269 55.856,87.12 56.945,85.385 C61.901,77.481 66.851,69.573 71.882,61.716 C73.131,59.766 73.309,57.946 72.911,55.621 C71.739,48.776 74.598,43.704 80.373,41.497 C86.513,39.15 92.117,40.987 95.884,46.889 C97.196,48.946 98.864,50.411 100.827,51.7 C105.981,55.083 111.174,58.409 116.234,61.926 C119.293,64.052 122.089,65.458 126.249,64.859 C132.821,63.911 138.328,68.545 139.244,74.583 C140.264,81.307 136.595,87.383 130.529,89.018 C123.867,90.812 117.104,87.739 115.481,80.999 C114.425,76.616 111.754,74.656 108.563,72.579 C105.77,70.761 103.002,68.904 100.235,67.048 C92.033,61.549 86.583,62.763 81.288,71.26 C77.148,77.905 72.964,84.522 68.848,91.182 C65.323,96.887 66.108,100.522 71.609,104.192 C83.943,112.421 96.324,120.579 108.602,128.89 C111.479,130.837 114.368,131.769 117.886,131.743 C136.05,131.607 154.214,131.648 172.378,131.709 C175.287,131.719 177.787,131.202 180.329,129.526 C184.955,126.477 189.925,126.896 194.41,129.953 C198.694,132.873 200.077,137.336 199.188,142.282 C198.249,147.502 195.016,151.097 189.759,152.052 C186.952,152.561 185.438,153.731 184.164,156.179 C167.261,188.657 150.295,221.101 133.24,253.498 C132.061,255.738 132.657,257.572 133.078,259.699 C134.522,267.005 130.867,273.403 124.471,275.063 C117.931,276.761 111.945,273.724 109.475,267.454 C107.114,261.463 109.248,255.043 115.053,252.096 C117.644,250.78 119.149,248.961 120.407,246.517 C125.66,236.307 131.022,226.153 136.564,215.682z";

export function S7Logo({ size = 28 }: { size?: number }) {
  // Original viewBox is 224x304 (tall). We render at given width with proportional height.
  const height = Math.round(size * (304 / 224));
  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 224 304"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-foreground"
      aria-hidden="true"
    >
      <path fill="currentColor" d={LOGO_PATH} />
    </svg>
  );
}

export function S7LogoSmall({ size = 18 }: { size?: number }) {
  const height = Math.round(size * (304 / 224));
  return (
    <div
      className="flex items-center justify-center rounded-full shrink-0 bg-muted text-foreground"
      style={{
        width: size + 12,
        height: size + 12,
      }}
    >
      <svg
        width={size}
        height={height}
        viewBox="0 0 224 304"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path fill="currentColor" d={LOGO_PATH} />
      </svg>
    </div>
  );
}
